export const CacheTypes = {
  PersistentCache: Symbol('PersistentCache'),
  DbCache: Symbol('DbCache'),
  MemoryCache: Symbol('MemoryCache'),
};
